// Out-of-stock override for the warehouse/store buffer rule (snippets/buy-buttons.liquid):
(function () {
  // Fallback if the merchandiser leaves the "Stock lookup API endpoint" theme setting blank.
  const DEFAULT_OOS_API_ENDPOINT = "https://jennifer-fisher-app-node.vercel.app/api/inventory";

  const lastCheckedVariantByElement = new WeakMap();

  function updateBuyButtons(buyButtons, variantId) {
    if (buyButtons.getAttribute("data-gift-card") === "true") {
      return;
    }

    if (buyButtons.getAttribute("data-is-bundle") === "true") {
      return;
    }

    const endpoint = window.themeVariables?.settings?.oosNotifyApiEndpoint || DEFAULT_OOS_API_ENDPOINT;
    if (!variantId || lastCheckedVariantByElement.get(buyButtons) === variantId) {
      return;
    }
    lastCheckedVariantByElement.set(buyButtons, variantId);

    let url;
    try {
      url = new URL(endpoint);
    } catch (error) {
      return;
    }
    url.searchParams.set("variant_id", variantId);

    fetch(url)
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        if (!data || typeof data.is_oos !== "boolean") {
          return;
        }

        // Made-to-order variants (data-made-to-order) stay shown as in-stock even if the live feed
        // says otherwise - this only ever blocks the "hide it" direction, never "show it".
        const isMadeToOrder = buyButtons.getAttribute("data-made-to-order") === "true";
        const isMadeToOrderOos = isMadeToOrder && data.is_oos;

        syncSkioWidgetVisibility(buyButtons.closest(".product-info"), isMadeToOrderOos ? false : data.is_oos);

        // ".sticky-add-to-cart" covers the mobile sticky Add to Cart bar's own copy of this
        // message (assets/sticky-add-to-cart.js), which lives outside ".product-info".
        const lowStockMessage = buyButtons
          .closest(".product-info, .sticky-add-to-cart")
          ?.querySelector(".only-few-in-stock");
        if (lowStockMessage) {
          if (lowStockMessage.previousElementSibling?.classList.contains("divider")) {
            lowStockMessage.previousElementSibling.hidden = data.is_oos;
          }
          lowStockMessage.hidden = data.is_oos;
        }
        const currentlyInStock = buyButtons.getAttribute("data-in-stock") === "true";
        if (currentlyInStock === !data.is_oos) {
          return;
        }

        const content = buyButtons.querySelector("[data-buy-buttons-content]");
        const altTemplate = buyButtons.querySelector("template[data-buy-buttons-alt-content]");
        if (!content || !altTemplate) {
          return;
        }
        if (!isMadeToOrderOos) {
          content.replaceChildren(altTemplate.content.cloneNode(true));
          buyButtons.setAttribute("data-in-stock", (!data.is_oos).toString());
          buyButtons.classList.toggle("buy-buttons--out-of-stock", data.is_oos);
        }

        const deliveryOptionsWrapper = buyButtons.closest(".product-info")?.querySelector(".delivery-options-wrapper");
        if (deliveryOptionsWrapper && !isMadeToOrderOos) {
          deliveryOptionsWrapper.hidden = data.is_oos || isMadeToOrder;
        }

        const purchaseTypeRow = buyButtons.closest(".product-info")?.querySelector("[data-purchase-type-row]");
        if (purchaseTypeRow && data.is_oos && !isMadeToOrderOos) {
          purchaseTypeRow.hidden = true;
        }

        const paymentTerms = buyButtons.closest(".product-info")?.querySelector("payment-terms");
        if (paymentTerms && data.is_oos && !isMadeToOrderOos) {
          paymentTerms.hidden = true;
        }

        const klarnaBlock = getKlarnaBlock(buyButtons);
        if (klarnaBlock && data.is_oos && !isMadeToOrderOos) {
          klarnaBlock.hidden = true;
        }
      })
      .catch(() => {});
  }

  function getKlarnaBlock(buyButtons) {
    return buyButtons
      .closest(".product-info, .sticky-add-to-cart")
      ?.querySelector(".klarna-app-block, .sticky-add-to-cart__klarna");
  }

  function syncSkioWidgetVisibility(root, isOos) {
    (root || document).querySelectorAll(".skio-plan-picker").forEach((picker) => {
      const blockWrapper = picker.closest(".product-info__block-item") || picker;
      const resolvedIsOos =
        typeof isOos === "boolean"
          ? isOos
          : picker.closest(".product-info")?.querySelector("buy-buttons[data-variant-id]")?.getAttribute("data-in-stock") ===
            "false";
      blockWrapper.hidden = resolvedIsOos;
    });
  }

 
  function updateSwatch(swatch, variantId) {
    if (swatch.getAttribute("data-gift-card") === "true") {
      return;
    }

    const endpoint = window.themeVariables?.settings?.oosNotifyApiEndpoint || DEFAULT_OOS_API_ENDPOINT;

    if (!variantId || lastCheckedVariantByElement.get(swatch) === variantId) {
      return;
    }
    lastCheckedVariantByElement.set(swatch, variantId);

    let url;
    try {
      url = new URL(endpoint);
    } catch (error) {
      return;
    }
    url.searchParams.set("variant_id", variantId);

    fetch(url)
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        if (!data || typeof data.is_oos !== "boolean") {
          return;
        }

        // Made-to-order swatches stay selectable even if the live feed says out of stock.
        const isMadeToOrder = swatch.getAttribute("data-made-to-order") === "true";
        if (!isMadeToOrder || !data.is_oos) {
          swatch.classList.toggle("is-disabled", data.is_oos);
        }
      })
      .catch(() => {});
  }

  function initAll(root) {
    (root || document).querySelectorAll("buy-buttons[data-variant-id]").forEach((buyButtons) => {
      updateBuyButtons(buyButtons, buyButtons.getAttribute("data-variant-id"));
    });

    (root || document).querySelectorAll("variant-picker [data-variant-id]").forEach((swatch) => {
      updateSwatch(swatch, swatch.getAttribute("data-variant-id"));
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll());
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (event) => initAll(event.target));
  document.addEventListener("dialog:after-show", (event) => initAll(event.target), true);


  document.addEventListener(
    "variant:change",
    (event) => {
      const formId = event.target.getAttribute("id");
      // Main buy-buttons and the sticky-bar buy-buttons share the same form id, so this needs to
      // update both, not just the first match.
      document.querySelectorAll(`buy-buttons[form="${CSS.escape(formId)}"]`).forEach((buyButtons) => {
        updateBuyButtons(buyButtons, event.detail.variant?.id);

        // The delivery-options block doesn't get re-rendered on variant switch, so sync its
        // visibility here from the freshly-rendered buy-buttons instead.
        const deliveryOptionsWrapper = buyButtons.closest(".product-info")?.querySelector(".delivery-options-wrapper");
        if (deliveryOptionsWrapper) {
          // Made-to-order variants never offer delivery/pickup (product-info.liquid skips this block
          // for them on page load), so hide it here too when switching onto one.
          deliveryOptionsWrapper.hidden =
            buyButtons.getAttribute("data-in-stock") === "false" ||
            buyButtons.getAttribute("data-made-to-order") === "true";
        }

        const klarnaBlock = getKlarnaBlock(buyButtons);
        if (klarnaBlock) {
          const isKlarnaEligible =
            Boolean(event.detail.variant?.available) && buyButtons.getAttribute("data-in-stock") === "true";
          klarnaBlock.hidden = !isKlarnaEligible;
        }
      });

      // Swatches are re-rendered fresh on every variant switch with only Liquid's guess (no live
      // check), so re-run the live check on them here too.
      document
        .querySelectorAll(`variant-picker[form-id="${CSS.escape(formId)}"] [data-variant-id]`)
        .forEach((swatch) => updateSwatch(swatch, swatch.getAttribute("data-variant-id")));
    },
    true
  );

  new MutationObserver((mutations) => {
    const skioWidgetInserted = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some(
        (node) => node.nodeType === Node.ELEMENT_NODE && (node.matches(".skio-plan-picker") || node.querySelector(".skio-plan-picker"))
      )
    );
    if (skioWidgetInserted) {
      syncSkioWidgetVisibility();
    }
  }).observe(document.body, { childList: true, subtree: true });
})();

// Bundle components
(function () {
  // Fallback if the merchandiser leaves the "Bundle components API endpoint" theme setting blank.
  const DEFAULT_BUNDLE_COMPONENTS_API_ENDPOINT = "https://jennifer-fisher-app-node.vercel.app/api/bundle-components";

  function gidToId(gid) {
    return typeof gid === "string" ? gid.split("/").pop() : null;
  }

  function escapeHtml(value) {
    const div = document.createElement("div");
    div.textContent = value == null ? "" : String(value);
    return div.innerHTML;
  }

  function stripHtml(html) {
    const div = document.createElement("div");
    div.innerHTML = html || "";
    return (div.textContent || "").replace(/\s+/g, " ").trim();
  }

  function truncate(text, maxLength) {
    if (text.length <= maxLength) {
      return text;
    }
    return `${text.slice(0, maxLength).trim()}…`;
  }

  const descriptionsByHandle = new Map();

  function fetchProductDescription(handle) {
    if (descriptionsByHandle.has(handle)) {
      return descriptionsByHandle.get(handle);
    }

    const request = fetch(`/products/${handle}.js`)
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => (data?.description ? truncate(stripHtml(data.description), 120) : null))
      .catch(() => null);

    descriptionsByHandle.set(handle, request);
    return request;
  }

  const DEFAULT_OOS_API_ENDPOINT = "https://jennifer-fisher-app-node.vercel.app/api/inventory";
  const oosRequestsByVariantId = new Map();

  function fetchVariantOosStatus(endpoint, variantId) {
    if (oosRequestsByVariantId.has(variantId)) {
      return oosRequestsByVariantId.get(variantId);
    }

    let url;
    try {
      url = new URL(endpoint);
    } catch (error) {
      return Promise.resolve(null);
    }
    url.searchParams.set("variant_id", variantId);

    const request = fetch(url)
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => (data && typeof data.is_oos === "boolean" ? data.is_oos : null))
      .catch(() => null)
      .finally(() => oosRequestsByVariantId.delete(variantId));

    oosRequestsByVariantId.set(variantId, request);
    return request;
  }

  function forceBuyButtonsOutOfStock(buyButtons) {
    if (buyButtons.getAttribute("data-in-stock") === "false") {
      return;
    }

    const content = buyButtons.querySelector("[data-buy-buttons-content]");
    const altTemplate = buyButtons.querySelector("template[data-buy-buttons-alt-content]");
    if (!content || !altTemplate) {
      return;
    }

    content.replaceChildren(altTemplate.content.cloneNode(true));
    buyButtons.setAttribute("data-in-stock", "false");
    buyButtons.classList.add("buy-buttons--out-of-stock");
  }

  function checkComponentsStock(formId, components) {
    if (!formId) {
      return;
    }

    const endpoint = window.themeVariables?.settings?.oosNotifyApiEndpoint || DEFAULT_OOS_API_ENDPOINT;
    const variantIds = [...new Set(components.map((component) => gidToId(component.variant_id)).filter(Boolean))];

    Promise.all(variantIds.map((variantId) => fetchVariantOosStatus(endpoint, variantId))).then((results) => {
      const anyComponentOos = results.some((isOos) => isOos === true);
      if (!anyComponentOos) {
        return;
      }

      document.querySelectorAll(`buy-buttons[form="${CSS.escape(formId)}"]`).forEach((buyButtons) => {
        forceBuyButtonsOutOfStock(buyButtons);
      });
    });
  }

  const requestsByProductId = new Map();

  function fetchBundleComponents(endpoint, productId) {
    if (requestsByProductId.has(productId)) {
      return requestsByProductId.get(productId);
    }

    let url;
    try {
      url = new URL(endpoint);
    } catch (error) {
      return Promise.resolve(null);
    }
    url.searchParams.set("product_id", productId);

    const request = fetch(url)
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => (data && data.is_bundle && Array.isArray(data.variants) ? data : null))
      .catch(() => null)
      .finally(() => requestsByProductId.delete(productId));

    requestsByProductId.set(productId, request);
    return request;
  }

  function findVariantEntry(data, variantId) {
    const target = String(variantId);
    return data.variants.find((entry) => gidToId(entry.variant_id) === target) || data.variants[0];
  }

  // A component is "choosable" when the same product (by handle) shows up with more than one distinct
  // title across the bundle's variants - e.g. the Beanie is "Black" in one bundle variant and "Charcoal"
  // in another, while the Arm Warmer stays "Default Title" throughout.
  function buildChoicesByHandle(data) {
    const choicesByHandle = new Map();

    data.variants.forEach((entry) => {
      const parentVariantId = gidToId(entry.variant_id);

      entry.components.forEach((component) => {
        const handle = component.product.handle;
        if (!choicesByHandle.has(handle)) {
          choicesByHandle.set(handle, []);
        }

        const choices = choicesByHandle.get(handle);
        if (!choices.some((choice) => choice.title === component.title)) {
          choices.push({ title: component.title, parentVariantId });
        }
      });
    });

    return choicesByHandle;
  }

  const DROPDOWN_CHEVRON_SVG =
    '<svg aria-hidden="true" focusable="false" fill="none" width="10" viewBox="0 0 10 6"><path d="m1 1 4 4 4-4" stroke="currentColor" stroke-linecap="square"/></svg>';

  function renderVariantPicker(productTitle, productHandle, choices, selectedTitle, showPlaceholder) {
    const strings = window.themeVariables?.strings || {};
    const popoverId = `popover-bundle-component-${escapeHtml(productHandle)}`;
    const radioGroupName = `bundle-component-${escapeHtml(productHandle)}`;
    const selectedChoice = !showPlaceholder ? choices.find((choice) => choice.title === selectedTitle) : null;
    const buttonLabel = selectedChoice ? selectedChoice.title : strings.selectColor || "Select Color";

    const options = choices
      .map((choice, index) => {
        const selected = selectedChoice === choice;
        const inputId = `${popoverId}-${index}`;
        return `
          <label class="popover__value-option h-stack justify-between gap-2" for="${inputId}" aria-selected="${selected ? "true" : "false"}">
            <input
              class="sr-only"
              type="radio"
              id="${inputId}"
              name="${radioGroupName}"
              value="${escapeHtml(choice.parentVariantId)}"
              data-bundle-variant-select
              ${selected ? "checked" : ""}
            >
            <span>${escapeHtml(choice.title)}</span>
          </label>
        `;
      })
      .join("");

    return `
      <div class="relative bundle-components__variant-picker">
        <button type="button" class="select" aria-controls="${popoverId}" aria-expanded="false">
          <span id="${popoverId}-selected-value" class="truncate-text">${escapeHtml(buttonLabel)}</span>
          ${DROPDOWN_CHEVRON_SVG}
        </button>

        <x-popover id="${popoverId}" class="popover popover--bottom-start color-scheme color-scheme--dialog" close-on-listbox-change>
          <p class="h5" slot="header">${escapeHtml(productTitle)}</p>
          <div class="popover__value-list">
            ${options}
          </div>
        </x-popover>
      </div>
    `;
  }

  function renderComponent(component, choicesByHandle, showPlaceholder) {
    const strings = window.themeVariables?.strings || {};
    const imageUrl = component.image?.url || component.product.image?.url;

    const imageMarkup = imageUrl
      ? `<img class="bundle-components__image-tag" src="${escapeHtml(imageUrl)}&width=200" width="72" height="72" loading="lazy" alt="${escapeHtml(component.image?.alt_text || component.product.image?.alt_text || component.product.title)}">`
      : "";

    const descriptionMarkup = `<p class="bundle-components__description text-sm text-subdued" data-component-description-for="${escapeHtml(component.product.handle)}" hidden></p>`;

    const choices = choicesByHandle.get(component.product.handle) || [];
    const pickerMarkup =
      choices.length > 1
        ? renderVariantPicker(component.product.title, component.product.handle, choices, component.title, showPlaceholder)
        : "";

    return `
      <div class="bundle-components__item">
        <div class="bundle-components__image">${imageMarkup}</div>
        <div class="bundle-components__info v-stack gap-1.5">
          <p class="bundle-components__title">${escapeHtml(component.product.title)}</p>
          ${descriptionMarkup}
          <a href="/products/${escapeHtml(component.product.handle)}" class="bundle-components__link text-sm">${escapeHtml(strings.seeFullDetails || "See Full Details")}</a>
          ${pickerMarkup}
        </div>
      </div>
    `;
  }

  class BundleComponents extends HTMLElement {
    connectedCallback() {
      this.statusEl = this.querySelector("[data-bundle-status]");
      this.listEl = this.querySelector("[data-bundle-list]");
      this.hasRenderedOnce = false;

      this.load();

      this.addEventListener("change", (event) => {
        const radio = event.target.closest("[data-bundle-variant-select]");
        if (!radio || !radio.value) {
          return;
        }

        const formId = this.getAttribute("data-form-id");
        const picker = formId && document.querySelector(`variant-picker[form-id="${CSS.escape(formId)}"]`);
        const marker = picker?.querySelector(`[data-variant-id="${CSS.escape(radio.value)}"]`);
        const input = marker?.matches("input") ? marker : marker?.control;

        if (input) {
          input.checked = true;
          input.dispatchEvent(new Event("change", { bubbles: true }));

          this.setAttribute("data-variant-id", radio.value);
          document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
          Promise.resolve(this.render(radio.value)).finally(() => {
            document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
          });
          return;
        }

        const url = new URL(window.location.href);
        url.searchParams.set("variant", radio.value);
        window.location.href = url.toString();
      });
    }

    load() {
      const endpoint = window.themeVariables?.settings?.bundleComponentsApiEndpoint || DEFAULT_BUNDLE_COMPONENTS_API_ENDPOINT;
      const strings = window.themeVariables?.strings || {};
      const productId = this.getAttribute("data-product-id");
      const variantId = this.getAttribute("data-variant-id");

      if (!endpoint || !productId || !variantId) {
        this.showError(strings);
        return;
      }

      this.setAttribute("data-state", "loading");
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));

      fetchBundleComponents(endpoint, productId)
        .then((data) => {
          if (!data) {
            this.showError(strings);
            return;
          }

          this.data = data;
          return this.render(variantId);
        })
        .finally(() => {
          document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
        });
    }

    showError(strings) {
      this.setAttribute("data-state", "error");
      if (this.statusEl) {
        this.statusEl.textContent = strings.bundleError || "We couldn't load this bundle's contents right now.";
      }
    }

    render(variantId) {
      if (!this.data) {
        return Promise.resolve();
      }

      const entry = findVariantEntry(this.data, variantId);
      if (!entry) {
        this.showError(window.themeVariables?.strings || {});
        return Promise.resolve();
      }

      const choicesByHandle = buildChoicesByHandle(this.data);
      const handles = [...new Set(entry.components.map((component) => component.product.handle))];

      checkComponentsStock(this.getAttribute("data-form-id"), entry.components);

      // Only the very first render shows each dropdown as an unselected "Select Color" placeholder -
      // any later render (the shopper actually picking a color) shows the real current selection.
      const showPlaceholder = !this.hasRenderedOnce;
      this.hasRenderedOnce = true;

      if (this.listEl) {
        this.listEl.innerHTML = entry.components
          .map((component) => renderComponent(component, choicesByHandle, showPlaceholder))
          .join("");
      }
      this.setAttribute("data-state", "loaded");

      handles.forEach((handle) => {
        fetchProductDescription(handle).then((description) => {
          if (!description) {
            return;
          }
          this.listEl?.querySelectorAll(`[data-component-description-for="${CSS.escape(handle)}"]`).forEach((el) => {
            el.textContent = description;
            el.hidden = false;
          });
        });
      });

      return Promise.resolve();
    }
  }

  if (!window.customElements.get("bundle-components")) {
    window.customElements.define("bundle-components", BundleComponents);
  }

  document.addEventListener("variant:change", (event) => {
    const formId = event.target.getAttribute("id");
    const variantId = event.detail?.variant?.id;
    if (!formId || !variantId) {
      return;
    }

    const bundleComponents = document.querySelector(`bundle-components[data-form-id="${CSS.escape(formId)}"]`);
    if (!bundleComponents || String(variantId) === bundleComponents.getAttribute("data-variant-id")) {
      return;
    }

    bundleComponents.setAttribute("data-variant-id", variantId);

    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
    Promise.resolve(bundleComponents.render(variantId)).finally(() => {
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
    });
  });
})();
